import {
  Component,
  Input,
  EventEmitter,
  Output,
  OnInit,
  ViewChild,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import { Match } from '../../../models';
import { MatTableDataSource, MatSort } from '@angular/material';

@Component({
  selector: 'matches-table-view',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './matches-table-view.component.html'
})
export class MatchesTableViewComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() matches: Match[];

  @Output() readonly delete = new EventEmitter<Match>();
  @Output() readonly edit = new EventEmitter<Match>();
  @Output() readonly export = new EventEmitter<Match>();
  @Output() readonly import = new EventEmitter<Match>();
  
  @ViewChild(MatSort) sort: MatSort;

  displayedColumns = ['name', 'homeTeam', 'awayTeam', 'matchDate', 'actions'];
  dataSource: MatTableDataSource<{}> = new MatTableDataSource([]);

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.info(changes);
    this.dataSource.data = this.matches;
  }

  onDelete(match: Match) {
    this.delete.emit(match);
  }

  onEdit(match: Match) {
    this.edit.emit(match);
  }

  onExport(match: Match) {
    this.export.emit(match);
  }

  onImport(match: Match) {
    this.import.emit(match);
  }
}
